import React, {useEffect, useState, useContext} from 'react';
import './App.css';
import Login from './routes/Auth/Login';
import Contact from './components/Contact/Contact';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import {getAuth} from 'firebase/auth';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {
  Provider as AuthProvider,
  Context as AuthContext,
} from './contexts/AuthContext';
import {Provider as DashboardProvider} from './contexts/DashboardContext';
import {
  Provider as FinancialProvider,
  Context as FinancialContext,
} from './contexts/FinancialContext';
import Settings from './routes/Settings/Settings';
import CreateAccount from './routes/Auth/CreateAccount';
import SignUp from './routes/Auth/Signup';
import ForgotPassword from './routes/Auth/ForgotPassword';
import {styled, createTheme, ThemeProvider} from '@mui/material/styles';
import {IntercomProvider, useIntercom} from 'react-use-intercom';
import {red} from '@mui/material/colors';
import DashboardHome from './routes/Dashboard/DashboardHome';
import PFMHome from './routes/FinancialManager/PFMHome';
import NotificationMenu from './routes/Notifications/NotificationMenu';
import ComingSoon from './routes/Auth/ComingSoon';

function App() {
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [success, setSuccess] = useState('');
  const [hasFetchedUserAuthState, setHasFetchedUserAuthState] = useState(false);
  const [userAuthState, setUserAuthState] = useState();

  const {
    state: {uid, client, authUser, universal},
  } = useContext(AuthContext);
  // const {state, getProfiles, getAtRisk, getFakeData} =
  //   useContext(DashboardContext);
  console.log('UID', uid, universal);

  const orgCode =
    universal && universal.organizationCode ? universal.organizationCode : null;
  // TODO: move to dashboard once know why causing inf loop
  // useEffect(() => {
  //   if (!orgCode || !universal.dashboard) {
  //     return;
  //   }
  //   if (universal.dashboard.role === 'owner') {
  //     getFakeData();
  //     // getProfiles();
  //     // getAtRisk();
  //   } else {
  //     getProfiles(orgCode);
  //     getAtRisk(orgCode);
  //   }
  // }, [orgCode]);

  const triggerSuccess = msg => {
    setShowSuccess(true);
    setSuccess(msg);
  };

  const triggerError = msg => {
    setShowError(true);
    setError(msg);
  };

  const handleErrorClose = () => {
    setShowError(false);
    setError('');
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    setSuccess('');
  };

  const RequireAuth = ({children, redirectTo}) => {
    if (userAuthState === undefined) {
      return <></>;
    }
    // IF AUTHENTICATED AND USER OBJECT
    if (userAuthState) {
      return children;
    }

    // IF NO AUTH
    return <Navigate to={redirectTo} />;
  };

  // thats destroyed once they navgite from the page
  React.useEffect(() => {
    if (!hasFetchedUserAuthState) {
      const auth = getAuth();
      auth.onAuthStateChanged(user => {
        if (user) {
          setHasFetchedUserAuthState(true);
          setUserAuthState(user);
          // User is signed in.
        } else {
          // No user is signed in.
          setHasFetchedUserAuthState(true);
          setUserAuthState(false);
        }
      });
    }
  });

  const INTERCOM_APP_ID = 'ww60whap';
  window.Intercom('shutdown');
  window.Intercom('boot', {
    app_id: INTERCOM_APP_ID,
  });

  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/signup"
            element={
              <SignUp showSuccess={triggerSuccess} showError={triggerError} />
            }
          />
          <Route
            path="/login"
            element={
              <Login showSuccess={triggerSuccess} showError={triggerError} />
            }
          />
          <Route
            path="/forgotPassword"
            element={
              <ForgotPassword
                showSuccess={triggerSuccess}
                showError={triggerError}
              />
            }
          />
          <Route
            path="/comingSoon"
            element={
              <RequireAuth redirectTo="/login">
                <ComingSoon />
              </RequireAuth>
            }
          />
          {/* <Route
            path="/settings"
            element={
              <RequireAuth redirectTo="/login">
                <Settings />
              </RequireAuth>
            }
          /> */}
          <Route
            path="/dashboard"
            element={
              <RequireAuth redirectTo="/login">
                <DashboardHome user={userAuthState} />
              </RequireAuth>
            }
          />
          <Route
            path="/pfm"
            element={
              <RequireAuth redirectTo="/login">
                <PFMHome user={userAuthState} />
              </RequireAuth>
            }
          />
          <Route
            path="/notifications"
            element={
              <RequireAuth redirectTo="/login">
                <NotificationMenu user={userAuthState} />
              </RequireAuth>
            }
          />
          {/* <Route
            path="/home"
            element={
              <RequireAuth redirectTo="/login">
                <Home
                  user={userAuthState}
                  showSuccess={triggerSuccess}
                  showError={triggerError}
                />
              </RequireAuth>
            }
          /> */}
          {/* <Route
            path="/contact"
            element={
              <RequireAuth redirectTo="/login">
                <Contact
                  user={userAuthState}
                  showSuccess={triggerSuccess}
                  showError={triggerError}
                />
              </RequireAuth>
            }
          /> */}
          <Route
            path="/"
            element={
              <Login showSuccess={triggerSuccess} showError={triggerError} />
            }
          />
        </Routes>
      </Router>
      {/* <Snackbar
        open={showSuccess}
        autoHideDuration={6000}
        onClose={handleSuccessClose}>
        <Alert
          onClose={handleSuccessClose}
          severity="success"
          sx={{width: '100%'}}>
          {success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={handleErrorClose}>
        <Alert onClose={handleErrorClose} severity="error" sx={{width: '100%'}}>
          {`An error occurred: ${error}`}
        </Alert>
      </Snackbar> */}
    </>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#F4F6FA',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },
});

export default () => {
  const INTERCOM_APP_ID = 'ww60whap';
  return (
    <IntercomProvider appId={INTERCOM_APP_ID}>
      <FinancialProvider>
        <DashboardProvider>
          <AuthProvider>
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </AuthProvider>
        </DashboardProvider>
      </FinancialProvider>
    </IntercomProvider>
  );
};
